import routes from './marketplace.routes'

export const marketplaceModule = {
  routes
}
